import { jsPDF } from "jspdf";
import { dinero } from "./posApi";

// ---------- EAN-13 ----------
const L = ["0001101", "0011001", "0010011", "0111101", "0100011", "0110001", "0101111", "0111011", "0110111", "0001011"];
const G = ["0100111", "0110011", "0011011", "0100001", "0011101", "0111001", "0000101", "0010001", "0001001", "0010111"];
const R = ["1110010", "1100110", "1101100", "1000010", "1011100", "1001110", "1010000", "1000100", "1001000", "1110100"];
const PARIDAD = ["LLLLLL", "LLGLGG", "LLGGLG", "LLGGGL", "LGLLGG", "LGGLLG", "LGGGLL", "LGLGLG", "LGLGGL", "LGGLGL"];

// 95 módulos (1 = barra) de un EAN-13
export const modulosEan13 = (codigo) => {
  const d = String(codigo).split("").map(Number);
  const par = PARIDAD[d[0]];
  let m = "101";
  for (let i = 1; i <= 6; i++) m += (par[i - 1] === "L" ? L : G)[d[i]];
  m += "01010";
  for (let i = 7; i <= 12; i++) m += R[d[i]];
  return m + "101";
};

// Dibuja el código en mm; las barras de guarda bajan un poco más, como en un EAN impreso
const dibujaEan13 = (doc, codigo, x, y, ancho, alto) => {
  const m = modulosEan13(codigo);
  const w = ancho / 95;
  const guarda = (i) => i < 3 || (i >= 45 && i < 50) || i >= 92;
  doc.setFillColor(0, 0, 0);
  let i = 0;
  while (i < 95) {
    if (m[i] === "1") {
      let j = i;
      while (j < 95 && m[j] === "1" && guarda(j) === guarda(i)) j++;
      doc.rect(x + i * w, y, (j - i) * w, alto + (guarda(i) ? 1.2 : 0), "F");
      i = j;
    } else i++;
  }
  // Dígitos espaciados y centrados a mano (align:center no considera el espaciado)
  doc.setFontSize(6.5).setFont(undefined, "normal");
  const txt = String(codigo), esp = 0.6;
  const total = doc.getTextWidth(txt) + esp * (txt.length - 1);
  doc.text(txt, x + (ancho - total) / 2, y + alto + 3.2, { charSpace: esp });
};

const recorta = (doc, texto, ancho) => {
  let t = String(texto || "");
  while (t.length > 3 && doc.getTextWidth(t) > ancho) t = t.slice(0, -2);
  return t === String(texto || "") ? t : t.trim() + "…";
};

// Contenido de una etiqueta dentro de un rectángulo (mm)
const etiqueta = (doc, e, x, y, w, h, conPrecio) => {
  const cx = x + w / 2;
  doc.setFont(undefined, "normal").setFontSize(6);
  doc.text(recorta(doc, `${process.env.REACT_APP_NOMBRE_INSTITUCION || ""} · ${e.codigo}`, w - 3), cx, y + 3, { align: "center" });
  doc.setFontSize(7);
  doc.text(recorta(doc, e.nombre, w - 3), cx, y + 6, { align: "center" });
  const variante = [e.color, e.talla && `Talla ${e.talla}`].filter(Boolean).join(" · ");
  doc.setFont(undefined, "bold").setFontSize(8.5);
  if (variante) doc.text(recorta(doc, variante, w - 3), cx, y + 9.5, { align: "center" });
  if (conPrecio && e.precioTienda) {
    doc.setFontSize(9.5);
    doc.text(dinero(e.precioTienda), cx, y + h - 1.6, { align: "center" });
  }
  const anchoCodigo = Math.min(w - 8, 38);
  dibujaEan13(doc, e.codigoBarras, cx - anchoCodigo / 2, y + 10.8, anchoCodigo, conPrecio ? h - 19.5 : h - 16);
};

// etiquetas: [{codigo, nombre, color, talla, precioTienda, codigoBarras, cantidad}]
// formato "rollo": una etiqueta de 50×25 mm por página (impresora térmica de etiquetas)
// formato "carta": hoja carta de 30 etiquetas (3×10, 66.7×25.4 mm)
export const imprimirEtiquetas = (etiquetas, { formato = "rollo", conPrecio = true } = {}) => {
  const piezas = etiquetas.flatMap((e) => Array.from({ length: Math.max(0, parseInt(e.cantidad, 10) || 0) }, () => e));
  if (!piezas.length) return 0;
  let doc;
  if (formato === "carta") {
    doc = new jsPDF("p", "mm", "letter");
    const W = 66.7, H = 25.4, mx = 4.8, my = 12.7, gap = 3.2;
    piezas.forEach((e, n) => {
      const k = n % 30;
      if (n && k === 0) doc.addPage();
      const col = k % 3, fila = Math.floor(k / 3);
      etiqueta(doc, e, mx + col * (W + gap), my + fila * H, W, H, conPrecio);
    });
  } else {
    doc = new jsPDF("l", "mm", [50, 25]);
    piezas.forEach((e, n) => {
      if (n) doc.addPage([50, 25], "l");
      etiqueta(doc, e, 0, 0, 50, 25, conPrecio);
    });
  }
  doc.autoPrint();
  const url = doc.output("bloburl");
  const previo = document.getElementById("pos-print-frame");
  if (previo) previo.remove();
  const f = document.createElement("iframe");
  f.id = "pos-print-frame";
  f.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;";
  f.src = url;
  document.body.appendChild(f);
  return piezas.length;
};
